import SearchSelect, { type SearchSelectItem } from '@/components/UI/SearchSelect';

interface StrategyScopeSelectProps {
    items: SearchSelectItem[];
    value: number[];
    onChange: (strategyIds: number[]) => void;
}

/**
 * Multi-select typeahead that scopes the whole performance page to a set of strategies. Options are grouped by
 * activity in the selected period and badged with subscription status; search matches name, id, status and group.
 */
const StrategyScopeSelect = ({ items, value, onChange }: StrategyScopeSelectProps) => (
    <SearchSelect
        noMargin
        aria-label="Strategy scope"
        items={items}
        mode="multi"
        noOptionsMessage="No strategy matches that name, id or status"
        placeholder="All strategies · type a name, id or status to scope the page"
        size="sm"
        value={value}
        onChange={onChange}
    />
);

export default StrategyScopeSelect;
